var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginLock1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.07143 9.25V6.5C5.07143 3.46243 7.50188 1 10.5 1C13.4981 1 15.9286 3.46243 15.9286 6.5V9.25M10.5 16.125C11.2495 16.125 11.8571 15.5094 11.8571 14.75C11.8571 13.9906 11.2495 13.375 10.5 13.375C9.75047 13.375 9.14286 13.9906 9.14286 14.75C9.14286 15.5094 9.75047 16.125 10.5 16.125ZM10.5 16.125V18.875M3.71429 23H17.2857C18.7848 23 20 21.7688 20 20.25V12C20 10.4812 18.7848 9.25 17.2857 9.25H3.71429C2.21523 9.25 1 10.4812 1 12V20.25C1 21.7688 2.21523 23 3.71429 23Z",
    stroke: "#7089F0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLock1);
export default __webpack_public_path__ + "static/media/login-lock1.b670ee151f4ac00af9a7f316667f0b3b.svg";
export { ForwardRef as ReactComponent };